import { num } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { PackageCheck } from "lucide-react";

const time = (iso) => (iso ? new Date(iso).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" }) : "–");

export const LogisticsToday = ({ rows }) => {
  const total = rows.reduce((s, r) => s + r.count, 0);
  return (
    <Card className="p-6" data-testid="logistics-today">
      <div className="mb-4 flex items-baseline justify-between gap-2">
        <h3 className="font-display text-lg font-semibold">Oggi</h3>
        <span className="text-sm"><span className="font-display text-2xl font-bold" data-testid="logistics-today-total">{num(total)}</span> pacchi</span>
      </div>
      {rows.length === 0 ? <p className="text-sm text-muted-foreground">Nessun pacco controllato oggi.</p> : (
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-5">
          {rows.map((r, i) => (
            <div key={r.name} className="rounded-lg border border-border/60 p-3" data-testid={`logistics-today-${i}`}>
              <p className="flex items-center gap-1.5 text-sm font-medium"><PackageCheck className="h-4 w-4 text-primary" />{r.name}</p>
              <p className="mt-1 font-display text-2xl font-bold">{num(r.count)}</p>
              <p className="text-xs text-muted-foreground">dalle {time(r.first)} alle {time(r.last)}{r.exchanges ? ` · ${r.exchanges} cambi/resi` : ""}</p>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export const LogisticsPackers = ({ rows, total, days }) => (
  <Card className="p-6" data-testid="logistics-packers">
    <h3 className="mb-4 font-display text-lg font-semibold">Totali ultimi {days} giorni</h3>
    {rows.length === 0 ? <p className="text-sm text-muted-foreground">Nessun pacco nel periodo.</p> : (
      <div className="space-y-3">
        {rows.map((r, i) => (
          <div key={r.name} className="flex flex-wrap items-center gap-3 text-sm" data-testid={`logistics-packer-${i}`}>
            <span className="w-28 shrink-0 font-medium">{r.name}</span>
            <div className="h-2 min-w-[120px] flex-1 overflow-hidden rounded-full bg-secondary"><div className="h-full rounded-full bg-primary" style={{ width: `${(r.total / Math.max(total, 1)) * 100}%` }} /></div>
            <span className="w-64 shrink-0 text-right text-xs text-muted-foreground">
              <b className="text-foreground">{num(r.total)} pacchi</b>{r.exchanges ? ` (di cui ${num(r.exchanges)} cambi/resi)` : ""} · {num(r.pieces)} capi · {r.days_active} giorni · {r.avg_per_day}/giorno
            </span>
          </div>
        ))}
      </div>
    )}
  </Card>
);
